export function backend() {
  return {
    $store: null,
    $events: null,
    $router: null,

    // ========================
    // send should be used by all other functions which access the API to reduce their code complexity
    // ========================
    async send(_={}, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false}){
      const event_bus=this.$events;
      var data= undefined;
      if (actions.trace)
        console.trace((_.method||"GET") + " " + _.route, _);
      try {
        var response=await fetch(makeUrl(_.route,_.params), {
          method:_.method || "GET",
          cache: 'no-cache', headers: {'user-agent': 'backend', 'content-type': 'application/json'},
          mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
          body: _.post_data ? JSON.stringify(_.post_data) : undefined,
        });
        if (!response.ok)
          throw new Error(`${response.status} ${response.statusText}`);
        data=await response.json();
        if (!data)
          throw new Error("Server response was empty!");
        if (!data.success)
          throw new Error(data.reason);
        if (!_.no_log)
          console.debug(_.route, _.params, data);
        if (!actions.no_notify)
          event_bus.$emit("notify", _.ok_message);
        (actions.onSuccess||NOOP)(data.rv);
        return data.rv;
      }
      catch (error) {
        //error.stack = error.stack + "\n" + callerStack;
        console.error(_.route, error.message, data);
        if (!actions.no_notify) {
          var details=_.no_error_details ? "" : "\r\n" + error.message;
          event_bus.$emit("error", (_.error_message || "") + ' ' + details);
        }
        (actions.onError||NOOP)(error.message||"Serverfehler", data||{});
        return null;
      }
      finally{
        if (actions.finally)
          actions.finally();
      }
    },

    // ========================
    // LOGIN
    // ========================
    async login(email, pw, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/login",
        params: { email: email, password: pw },
        ok_message: undefined,
        error_message: "Login fehlgeschlagen!"
      }, actions);
    },

    // ========================
    // Gast Login (admin)
    // ========================
    async gast_login(email, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/guest_login",
        params: { token: this.$store.state.token, email },
      }, actions);
    },

    // ========================
    // LOGOUT
    // ========================
    async logout(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true}){
      return await this.send({
        route:"/api/logout",
        params: { token: this.$store.state.token },
      }, actions);
    },

    // ========================
    // GAST LOGOUT
    // ========================
    async gast_logout(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true}){
      return await this.send({
        route:"/api/guest_logout",
        params: { token: this.$store.state.token },
      }, actions);
    },

    // ========================
    // CHECK SESSION
    // ========================
    async check_session(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false}){
      return await this.send({
        route:"/api/check_session",
        params: { token: this.$store.state.token },
        ok_message: undefined,
        error_message: "Login-Session nicht mehr gültig!",
        no_log:true,
      }, actions);
    },

    // ========================
    // Account signup
    // ========================
    async register(user={ email:'', password: '' },
             actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/signup",
        method:"POST",
        post_data: user,
        ok_message: "Registrierung erfolgreich!",
        error_message: "Registrierung fehlgeschlagen!"
      }, actions);
    },

    // ========================
    // Temp Link Verification
    // ========================
    async verify(id="", actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/verify",
        params: { id },
        ok_message: "Aktivierung erfolgreich!",
        error_message: "Aktivierung fehlgeschlagen!"
      }, actions);
    },

    // ========================
    // Request new Verification Email
    // ========================
    request_activation_email(email="", actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("request_activation_email: " + email)
      fetch("/api/request_activation_email?" + query({email: email}),{
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'GET', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess();
        } else {
          console.error("request_verify_email failed. reason: " + data.reason + "\n" + data.error)
          if (!actions.no_notify)
            this.$events.$emit("notify", "Fehler: " + data.reason)
          if (actions.onError)
            actions.onError(data.reason);
        }
        if (actions.finally)
          actions.finally();
        this.trying = false;
      }).catch(error => {
        console.error(error);
        this.$events.$emit("notify", "Serverfehler! Bitte kontaktieren Sie den Support. ")
        if (actions.onError)
          actions.onError(error);
        if (actions.finally)
          actions.finally();
      })
    },

    // ========================
    // Request PW reset
    // ========================
    request_pw_reset(email="", actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("request_pw_reset_email: " + email)
      fetch("/api/request_pw_reset_email?" + query({email: email}),{
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'GET', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess();
        } else {
          console.error("request_pw_reset_email failed. reason: " + data.reason + "\n" + data.error)
          if (!actions.no_notify)
            this.$events.$emit("notify", "Fehler: " + data.reason)
          if (actions.onError)
            actions.onError(data.reason);
        }
        if (actions.finally)
          actions.finally();
        this.trying = false;
      }).catch(error => {
        console.error(error);
        this.$events.$emit("notify", "Serverfehler! Bitte kontaktieren Sie den Support. ")
        if (actions.onError)
          actions.onError(error);
        if (actions.finally)
          actions.finally();
      })
    },

    // ========================
    // change PW
    // ========================
    async change_password(old_pw, new_pw, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/change_password",
        params: { token: this.$store.state.token, old_pw, new_pw },
        ok_message: "Passwort geändert!",
        error_message: "Passwortänderung fehlgeschlagen!"
      }, actions);
    },

    // ========================
    // Change PW with reset code
    // ========================
    reset_password(data={id:"", pw:""}, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("reset_password: " + data.id)
      fetch("/api/reset_pw_with_code",{
        body: JSON.stringify(data),
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'POST', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess();
        } else {
          console.error("reset_password failed. reason: " + data.reason + "\n" + data.error)
          if (!actions.no_notify)
            this.$events.$emit("notify", "Fehler: " + data.reason)
          if (actions.onError)
            actions.onError(data.reason);
        }
        if (actions.finally)
          actions.finally();
        this.trying = false;
      }).catch(error => {
        console.error(error);
        this.$events.$emit("notify", "Serverfehler! Bitte kontaktieren Sie den Support. ")
        if (actions.onError)
          actions.onError(error);
        if (actions.finally)
          actions.finally();
      })
    },

    // ========================
    // GET SETTINGS
    // ========================
    async get_settings(context, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true})
    {
      return await this.send({
        route:"/api/get_settings",
        params: { token: this.$store.state.token, context },
        ok_message: undefined,
        error_message: "Konnte Einstellungen nicht laden!"
      }, actions);
    },

    // ========================
    // SET SETTINGS
    // ========================
    async set_settings(context, data, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/set_settings",
        params: { token: this.$store.state.token, context },
        method: "POST",
        post_data: data,
        ok_message: "Gespeichert",
        error_message: "Konnte nicht speichern!"
      }, actions);
    },

    // ========================
    // LITEDB QUERY
    // ========================
    litedb_query(sql, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("litedb_query")
      fetch("/api/litedb_query?" + query({token: this.$store.state.token, sql: sql}),{
        //body: JSON.stringify(data),
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'GET', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess(data.result);
          // if (!actions.no_notify)
          //     this.$events.$emit("notify", "Success.")
        } else {
          console.error("litedb_query failed. reason: " + data.reason + "\n" + data.error)
          if (actions.onError)
            actions.onError(data.reason);
          if (!actions.no_notify)
            this.$events.$emit("error", "Fehler bei DB-Abfrage!")
        }
        if (actions.finally)
          actions.finally();
      }).catch(error => {
        console.error(error);
        this.$events.$emit("error", "Serverfehler!")
        if (actions.onError)
          actions.onError(error||"Serverfehler");
        if (actions.finally)
          actions.finally();
      })
    },

    // ========================
    // GET_USERS (admin)
    // ========================
    async get_users(qty, offset, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true})
    {
      return await this.send({
        route:"/api/get_users",
        params: { token: this.$store.state.token, qty, offset },
      }, actions);
    },

    // ========================
    // GET USER (admin)
    // ========================
    async get_user(email, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true})
    {
      return await this.send({
        route:"/api/get_user",
        params: { token: this.$store.state.token, email },
      }, actions);
    },

    // ========================
    // SAVE USER (admin)
    // ========================
    async save_user(user, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/save_user",
        params: { token: this.$store.state.token },
        method: "POST",
        post_data: user,
        ok_message: "User saved!",
        error_message: "Save failed!"
      }, actions);
    },

    // ========================
    // DELETE USER (admin)
    // ========================
    async delete_user(email, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      return await this.send({
        route:"/api/delete_user",
        params: { token: this.$store.state.token, email },
        ok_message: "User deleted!",
        error_message: "Delete failed!"
      }, actions);
    },

    // ========================
    // LOGS
    // ========================

    // log_nr should be -1 on first call, then the _id of the oldest log retrieved
    async get_logs_before(log_nr, qty, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      actions.no_notify=true;
      return await this.send({
        route:"/api/get_logs_before",
        params: { token: this.$store.state.token, log_nr, qty },
      }, actions);
    },

    // log_nr should be the _id of the most recent log retrieved
    async get_logs_after(log_nr, qty, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      actions.no_notify=true;
      return await this.send({
        route:"/api/get_logs_after",
        params: { token: this.$store.state.token, log_nr, qty },
      }, actions);
    },

    async clear_logs(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      actions.no_notify=true;
      return await this.send({
        route:"/api/clear_logs",
        params: { token: this.$store.state.token },
      }, actions);
    },

    // ========================
    // DB Import
    // ========================
    db_import(data, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("db_import")
      fetch("/api/db_import?" + query({token: this.$store.state.token, }),{
        body:data, // <-- note: no stringification here as the data is already JSON
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'POST', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess(data.rv);
          if (!actions.no_notify)
            this.$events.$emit("notify", "Gespeichert.")
        } else {
          console.error("update_region failed. reason: " + data.reason + "\n" + data.error)
          if (actions.onError)
            actions.onError(data.reason);
          if (!actions.no_notify)
            this.$events.$emit("error", "Nicht gespeichert")
        }
        if (actions.finally)
          actions.finally();
      }).catch(error => {
        console.error(error);
        this.$events.$emit("error", "Serverfehler!")
        if (actions.onError)
          actions.onError(error||"Serverfehler");
        if (actions.finally)
          actions.finally();
      })
    },


    // ========================
    // !!! DB RESET !!!
    // ========================
    db_reset(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("db_reset")
      fetch("/api/db_reset?" + query({token: this.$store.state.token, }),{
        //body:data,
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'GET', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess(data.rv);
          if (!actions.no_notify)
            this.$events.$emit("notify", "DB Reset durchgeführt.")
        } else {
          console.error("db_reset failed. reason: " + data.reason + "\n" + data.error)
          if (actions.onError)
            actions.onError(data.reason);
          if (!actions.no_notify)
            this.$events.$emit("error", "DB Reset nicht erfolgreich.")
        }
        if (actions.finally)
          actions.finally();
      }).catch(error => {
        console.error(error);
        this.$events.$emit("error", "Serverfehler!")
        if (actions.onError)
          actions.onError(error||"Serverfehler");
        if (actions.finally)
          actions.finally();
      })
    },


    // ========================
    // Get Maintenance Mode
    // ========================
    async get_maintenance_mode(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true})
    {
      return await this.send({
        route:"/api/get_maintenance_mode",
        params: {  },
      }, actions);
    },

    // ========================
    // Set Maintenance Mode
    // ========================
    set_maintenance_mode(mode_on, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("set_maintenance_mode")
      fetch("/api/set_maintenance_mode?" + query({token: this.$store.state.token, mode_on:mode_on }),{
        //body:data,
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'GET', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess(data.rv);
          if (!actions.no_notify)
            this.$events.$emit("notify", "Wartungsmodus = " + (data.rv ? "EIN" : "AUS"));
        } else {
          console.error("set_maintenance_mode failed. reason: " + data.reason + "\n" + data.error)
          if (actions.onError)
            actions.onError(data.reason);
          if (!actions.no_notify)
            this.$events.$emit("error", "Wartungsmodus konnte nicht gesetzt werden.")
        }
        if (actions.finally)
          actions.finally();
      }).catch(error => {
        console.error(error);
        this.$events.$emit("error", "Serverfehler!")
        if (actions.onError)
          actions.onError(error||"Serverfehler");
        if (actions.finally)
          actions.finally();
      })
    },

    // ========================
    // Send Testemail
    // ========================
    send_test_email(email, context=null, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false})
    {
      console.log("send_test_email", {token: this.$store.state.token, email, context })
      fetch("/api/send_test_email?" + query({token: this.$store.state.token, email, context }),{
        //body:data,
        cache: 'no-cache', headers: {'user-agent': 'sphinxx-web', 'content-type': 'application/json'},
        method: 'GET', mode: 'cors', redirect: 'follow', referrer: 'no-referrer',
      }).then(function (response) {
        if (response.ok)
          return response.json();
      }).then(data => {
        if (data.success) {
          if (actions.onSuccess)
            actions.onSuccess(data.rv);
          if (!actions.no_notify)
            this.$events.$emit((data.rv ? "notify":"error"), "Testemail " + (data.rv ? "wurde versandt." : "konnte nicht versandt werden."));
        } else {
          console.error("send_test_email failed. reason: " + data.reason + "\n" + data.error)
          if (actions.onError)
            actions.onError(data.reason);
          if (!actions.no_notify)
            this.$events.$emit("error", "Testemail konnte nicht versandt werden.")
        }
        if (actions.finally)
          actions.finally();
      }).catch(error => {
        console.error(error);
        this.$events.$emit("error", "Serverfehler!")
        if (actions.onError)
          actions.onError(error||"Serverfehler");
        if (actions.finally)
          actions.finally();
      })
    },


    // ========================
    // GET OBJECT
    // ========================
    async get_object(kind, id, create, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      if (!kind || !id)
        return;
      return await this.send({
        route:"/api/get_object",
        params: { token: this.$store.state.token, kind, id, create },
        ok_message: undefined,
        error_message: "Konnte Objekt nicht laden!"
      }, actions);
    },

    // ========================
    // SET OBJECT
    // ========================
    async set_object(kind, id, data, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      if (!kind || !id)
        return;
      return await this.send({
        route:"/api/set_object",
        params: { token: this.$store.state.token, kind, id },
        method: "POST",
        post_data: data,
        ok_message: "Gespeichert",
        error_message: "Konnte nicht speichern!"
      }, actions);
    },

    // ========================
    // DELETE OBJECT
    // ========================
    async delete_object(kind, id, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route:"/api/delete_object",
        params: { token: this.$store.state.token, kind, id },
        ok_message: "Gelöscht",
        error_message: "Konnte nicht löschen!"
      }, actions);
    },

    // ========================
    // GET ALL OBJECTS
    // ========================
    async get_all_objects(kind, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route:"/api/get_all_objects",
        params: { token: this.$store.state.token, kind },
        ok_message: undefined,
        error_message: "Konnte Objekt nicht laden!"
      }, actions);
    },


    // ========================
    // GET ALL OBJECTS
    // ========================
    async get_all_objects_bunched(kind, count, offset, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route:"/api/get_all_objects_bunched",
        params: { token: this.$store.state.token, kind, count, offset },
        ok_message: undefined,
        error_message: "Konnte Objekt nicht laden!"
      }, actions);
    },

    // ========================
    // GET FILTERED OBJECTS
    // ========================
    async get_filtered_objects(kind, filter, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      if (!kind || !filter)
        return;
      return await this.send({
        route:"/api/get_filtered_objects",
        params: { token: this.$store.state.token, kind },
        method: "POST",
        post_data: filter,
        ok_message: undefined,
        error_message: "Konnte Objekte nicht abfragen!"
      }, actions);
    },

    // num: -7 gets today and the past 6 indices
    async get_daily_values(kind, iso_date, num, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route: "/api/get_daily_values",
        params: { token: this.$store.state.token, kind, iso_date, num },
        ok_message: undefined,
        error_message: "Konnte Werte nicht laden!"
      }, actions);
    },

    // num: -7 gets today and the past 6 records
    async get_daily_records(iso_date, activity_id, num, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route: "/api/get_daily_records",
        params: { token: this.$store.state.token, iso_date, activity_id, num },
        ok_message: undefined,
        error_message: "Konnte Werte nicht laden!"
      }, actions);
    },

    async request_feedback(email, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route: "/api/request_feedback",
        params: { token: this.$store.state.token, email },
        ok_message: "Feedback angefordert!",
        error_message: "Feedback konnte nicht angefordert werden!"
      }, actions);
    },

    async external_feedback(info, feedback, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route: "/api/external_feedback",
        params: {  },
        method: "POST",
        post_data: { info, feedback },
        ok_message: "Feedback eingereicht",
        error_message: "Feedback konnte nicht eingereicht werden!"
      }, actions);
    },

    async invite(email, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      return await this.send({
        route: "/api/invite",
        params: { token: this.$store.state.token, email },
        ok_message: "Einladung abgesendet!",
        error_message: "Einladung konnte nicht gesendet werden!"
      }, actions);
    },

    // ========================
    // GET STATS
    // ========================
    async get_stats(context, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: true })
    {
      if (!context)
        return;
      return await this.send({
        route:"/api/get_stats",
        params: { token: this.$store.state.token, context },
        ok_message: undefined,
        error_message: "Konnte Objekt nicht laden!"
      }, actions);
    },

    // ========================
    // GET TEAM TREE
    // ========================
    async get_team_tree(iso_date, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/get_team_tree",
        params: { token: this.$store.state.token, iso_date },
        ok_message: undefined,
        error_message: "Konnte Teamstruktur nicht laden!"
      }, actions);
    },

    // ========================
    // RECALC INDEX
    // ========================
    async recalc_index(email, iso_date, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/recalc_index",
        params: { token: this.$store.state.token, email, iso_date },
        ok_message: undefined,
        error_message: "Konnte INDEX nicht re-calc-en!"
      }, actions);
    },

    // ========================
    // GET ZIELE
    // ========================
    async get_ziele(year, memberEmail, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/get_ziele",
        params: { token: this.$store.state.token, year, memberEmail },
        ok_message: undefined,
        error_message: "Konnte Ziele von Teammitglied "+memberEmail+" nicht laden!"
      }, actions);
    },

    // ========================
    // GET SMS STATS
    // ========================
    async get_sms_stats(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/get_sms_stats",
        params: { token: this.$store.state.token, },
        ok_message: undefined,
        error_message: "Konnte SMS Stats nicht laden!"
      }, actions);
    },

    // ========================
    // Send SMS
    // ========================
    async send_sms(phone, text, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/send_sms",
        params: { token: this.$store.state.token, phone, text},
        ok_message: undefined,
        error_message: "Konnte SMS nicht an "+phone+" senden!"
      }, actions);
    },

    // ========================
    // Get current streak
    // ========================
    async get_current_streak(streakId, actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/get_current_streak",
        params: { token: this.$store.state.token, streakId},
        ok_message: undefined,
        error_message: "Konnte Strähne "+streakId+" nicht auslesen!"
      }, actions);
    },

    // ========================
    // Get activity sums including ziele for every week
    // ========================
    async get_activity_sums_with_targets(actions={onSuccess: undefined, onError: undefined, finally: undefined, no_notify: false })
    {
      return await this.send({
        route:"/api/get_activity_sums_with_targets",
        params: { token: this.$store.state.token },
        ok_message: undefined,
        error_message: "Konnte get_activity_sums_with_targets nicht ausführen!"
      }, actions);
    },


  }
}


const NOOP = () => { /* don't do nothing here */ }

function makeUrl(route, params=undefined) {
  if (!params)
    return route;
  return route + "?" + query(params);
}

function query(data) {
  let ret = [];
  for (let d in data)
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
}
